import EventEditLayout from '@/components/Event/EventEditLayout';

export const unstable_settings = {
  anchor: 'index',
};

export default function PrivateEventEventIdEditLayoutRoute() {
  return <EventEditLayout />;
}
